module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm1.e7134e26c5b265a96c4369868d762a4b.png";